import React, { useState, useEffect } from "react"
import hello from "hellojs"
import jwt_decode from "jwt-decode"
import { getAuthResponse } from "../authn";

type AuthEvent = {
  network: string
  authResponse?: hello.HelloJSAuthResponse
  unchanged?: boolean
}

// function useHelloJsState(init: () => { [key: string]: Required<hello.HelloJSAuthResponse> | undefined }) {
//   const [sessions, setSessions] = useState(init)
//   const sessionsRef = useRef(sessions)
//   useEffect(() => {
//     function tryUpdateSession(auth: AuthEvent) {
//       if (!auth.unchanged) {
//         console.log("session update")
//         setSessions({ ...sessionsRef.current, [auth.network]: auth.authResponse as Required<hello.HelloJSAuthResponse> })
//       }
//     }
//     hello.on("auth", tryUpdateSession)
//     return () => {
//       hello.off("auth", tryUpdateSession)
//     }
//   }, [sessionsRef])
//   return sessions
// }

export function useCachedResponse(scope?: string, network?: string) {
  const [response, setResponse] = useState<Required<hello.HelloJSAuthResponse> | undefined>(undefined)

  useEffect(() => {
    function tryUpdateSession(auth: AuthEvent) {
      if (!auth.unchanged) {
        setResponse(auth.authResponse as Required<hello.HelloJSAuthResponse>)
      }
    }

    hello.on("auth", tryUpdateSession)
    setResponse(getAuthResponse(scope, network))
    return () => {
      hello.off("auth", tryUpdateSession)
    }
  }, [scope, network])

  return response
}

export function useIdentity<T>(scope?: string, network?: string) {
  const response = useCachedResponse(scope, network)
  return response ? jwt_decode<T>(response.id_token) : undefined
}

// export function useAuthenticatedClient(scope?: string, network?: string) {
//   return React.useMemo(() => {
//     const instance = axios.create()
//     instance.interceptors.request.use(async config => {
//       const token = await getToken(scope, network)
//       if (token == undefined) {
//         throw new Error("could not get token")
//       }
//       if (!config.headers) { config.headers = {} }
//       config.headers["Authorization"] = `Bearer ${token}`
//       return config
//     })
//     return instance
//   }, [scope, network])
// }
